// IMPORT REACT
import React from 'react';

// IMPORT STYLES
import { SC_p, SC_span, SC_h1, SC_h2, SC_h5, SC_div } from './styles';

const identifyComponent = (tag) => {
  const components = {
    'p': SC_p,
    'span': SC_span,
    'h1': SC_h1,
    'h2': SC_h2,
    'h5': SC_h5,
    'div': SC_div
  }
   return components[tag] ? components[tag] : components['p'];
} 

const YAText = (props) => {   

  let Template = identifyComponent(props.tag)
  if(props.addOn){
    return (
      <Template style={props.style} divider={props.divider} textAlign={props.textAlign} hasAddOn className={props.bootstrap} >
        <span dangerouslySetInnerHTML={{__html: props.children}}/>
        {props.addOn}
      </Template>
    )
  }

  return (
    <Template style={props.style} divider={props.divider} textAlign={props.textAlign} className={props.bootstrap} dangerouslySetInnerHTML={{__html: props.children}} />
  );
    
}
export default YAText;